import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.PROFILES,
    method: "get",
    params,
  });
}

function setProfiles(data) {
  localStorage.setItem("profiles", JSON.stringify(data));
}

function getProfiles() {
  try {
    return JSON.parse(localStorage.getItem("profiles")) || null;
  } catch (_) {
    return null;
  }
}

export default {
  list,
  setProfiles,
  getProfiles
};
